// Date formatting utilities that work consistently between server and client
// Avoids hydration mismatches by using fixed locale formatting

export function formatDate(date: string | Date, options?: {
    showYear?: boolean;
    showTime?: boolean;
}) {
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear() + 543; // Buddhist year

    const thaiMonths = [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
    ];

    let result = `${day} ${thaiMonths[month]}`;

    if (options?.showYear !== false) {
        result += ` ${year}`;
    }

    if (options?.showTime) {
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        result += ` ${hours}:${minutes}`;
    }

    return result;
}

export function formatDateShort(date: string | Date) {
    return formatDate(date, { showYear: false });
}

export function formatDateTime(date: string | Date) {
    return formatDate(date, { showTime: true });
}
